const platformTransformer = response => {
  return response.map(({ id, name }) => ({ id: id.toString(), name }))
}

export default platformTransformer
